import Common from './Common'
import QOS from './QOS'
import AccessControl from './AccessControl'
import Gateway from './Gateway'
import AlarmEvent from './AlarmEvent'
import FlowControl from './FlowControl'
import StatisticalAnalysis from './StatisticalAnalysis'
import ReportFormsAnalysis from './ReportFormsAnalysis'
import Dashboard from './Dashboard'
import SubUser from './SubUser'
import OpenService from './OpenService'
import NetworkTopology from './NetworkTopology'
import OperationLog from './OperationLog'
import CMI from './CMI'


// eslint-disable-next-line import/no-anonymous-default-export
export default {
  Common,
  QOS,
  AccessControl,
  Gateway,
  AlarmEvent,
  FlowControl,
  StatisticalAnalysis,
  ReportFormsAnalysis,
  Dashboard,
  SubUser,
  OpenService,
  NetworkTopology,
  OperationLog,
  CMI
}